import { Endpoint, notificationToken } from "./contants";
import {
  apiPostRequest,
  ApiType,
  createEncryptedPayload,
  APIResponse
} from "./util/apiUtils";
import {
  LoginResponse,
  LoginPayload,
} from "./response_payload/LoginResponseRP";
import { ContactType } from "./models/ContactType";
import { VerifyAccountForResetPasswordType } from "./models/VerifyAccountForResetPasswordType";
import { SendVerifyCodeAction } from "./models/SendVerifyCodeAction";
import {
  VerifyAccountForResetPasswordPayload,
  VerifyAccountForResetPasswordResponse,
} from "./response_payload/VerifyAccountForResetPasswordRP";
import { SendVerifyCodePayload } from "./response_payload/SendVerifyCodeRP";
import { VerifyCodePayload } from "./response_payload/VerifyCodeRP";
import { ResetPasswordPayload } from "./response_payload/ResetPasswordRP";

const validate = (value: string, fieldName: string) => {
  if (!value) {
    throw new Error(
      `The field "${fieldName}" is required and cannot be empty.`
    );
  }
  return value;
};

export const loginByUsername = async (
  username: string,
  password: string
): Promise<APIResponse<LoginResponse> | null> => {
  const androidVersion = "1.0.0";
  const phoneBrand = "iPhone";
  const phoneModel = "13 Pro Max";
  const phoneImei = "123456789";
  const lineBrand = "Telstra";
  const lineCountry = "Australia";
  const appVersion = "1.0.0";

  const basePayload: LoginPayload = {
    Username: username,
    Password: password,
    NotificationToken: notificationToken,
    OSVersion: androidVersion,
    Platform: 1,
    PhoneBrand: phoneBrand,
    PhoneModel: phoneModel,
    PhoneImei: phoneImei,
    LineBrand: lineBrand,
    LineCountry: lineCountry,
    AppVersion: appVersion,
  };

  const hashPayload = `${validate(username, "username")}${validate(
    password,
    "password"
  )}${validate(notificationToken, "notificationToken")}`;
  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  return await apiPostRequest<LoginResponse>(Endpoint.Login, encryptedPayload);
};

export const VerifyAccountForResetPassword = async (
  type: ContactType,
  verifyType: VerifyAccountForResetPasswordType,
  contact: string
): Promise<APIResponse<VerifyAccountForResetPasswordResponse> | null> => {
  const basePayload: VerifyAccountForResetPasswordPayload = {
    Type: type,
    VerifyType: verifyType,
    Contact: contact,
  };

  const hashPayload = `${type}${verifyType}${validate(contact, "contact")}`;

  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  return await apiPostRequest<VerifyAccountForResetPasswordResponse>(
    Endpoint.VerifyAccountForResetPassword,
    encryptedPayload
  );
};

export const SendVerifyCode = async (
  action: SendVerifyCodeAction,
  type: ContactType,
  contact: string
): Promise<APIResponse<string> | null> => {
  const basePayload: SendVerifyCodePayload = {
    Action: action,
    Type: type,
    Contact: contact,
  };

  const hashPayload = `${action}${type}${validate(contact, "contact")}`;

  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  return await apiPostRequest<string>(
    Endpoint.SendVerifyCode,
    encryptedPayload
  );
};

export const VerifyCode = async (
  action: SendVerifyCodeAction,
  type: ContactType,
  contact: string,
  verifyCode: string
): Promise<APIResponse<string> | null> => {
  const basePayload: VerifyCodePayload = {
    Action: action,
    Type: type,
    Contact: contact,
    VerifyCode: verifyCode,
  };

  const hashPayload = `${action}${type}${validate(
    contact,
    "contact"
  )}${validate(verifyCode, "verifyCode")}`;

  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  
  return await apiPostRequest<string>(Endpoint.VerifyCode, encryptedPayload);
};


export const VerifyEmailCode = async (
  email: string,
  verifyCode: string
): Promise<APIResponse<string> | null> => {
  const basePayload = {
    "Email": email,
    "VerifyCode": verifyCode
  }

  const hashPayload = `${validate(
    email,
    "email"
  )}${validate(verifyCode, "verifyCode")}`;

  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  return await apiPostRequest<string>(Endpoint.VerifyEmail, encryptedPayload);
};

export const ResetPassword = async (
  action: SendVerifyCodeAction,
  type: ContactType,
  contact: string,
  verifyCode: string,
  password: string
): Promise<APIResponse<string> | null> => {
  const basePayload: ResetPasswordPayload = {
    Action: action,
    Type: type,
    Contact: contact,
    VerifyCode: verifyCode,
    Password: password,
  };

  const hashPayload = `${action}${type}${validate(
    contact,
    "contact"
  )}${validate(verifyCode, "verifyCode")}${validate(password, "password")}`;

  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  return await apiPostRequest<string>(Endpoint.ResetPassword, encryptedPayload);
};

export const CheckEmailExist = async (email: string): Promise<APIResponse<string> | null> => {
  const basePayload = {
    "Email" : email,
  };
  const hashPayload = `${validate(email, "Email")}`;
  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  return await apiPostRequest<string>(Endpoint.CheckEmail, encryptedPayload);

};

export const CheckUsernameExist = async (username: string): Promise<APIResponse<string> | null> => {
  const basePayload = {
    "Username" : username,
  };
  const hashPayload = `${validate(username, "Username")}`;
  const encryptedPayload = createEncryptedPayload(
    basePayload,
    hashPayload,
    ApiType.Main
  );

  return await apiPostRequest<string>(Endpoint.CheckUsername, encryptedPayload);

};